import styles from './OpinionsSlide.module.scss';

import { useHapticFeedback } from '@/hooks/useHapticFeedback';
import { useNavigation } from '@/hooks/useNavigation';
import { NOTIFICATION_TYPE } from '@/modules/notification/types';
import {
  OpinionPoll,
  OpinionsApi,
  useOpinionContext,
} from '@/modules/opinions';
import { OpinionSlideContent } from '@/modules/opinions/components';
import { PAGE } from '@/modules/page/routes';
import { useStore } from '@/store';
import cn from 'classnames';

import DislikeIcon from './images/dislike.svg?react';
import CloseIcon from '@/modules/ugc/components/CreateOpinion/images/close.svg?react';
import { useTranslation } from 'react-i18next';
import { useSwiper } from 'swiper/react';

export const OpinionSlide = ({ item }: { item: OpinionPoll }) => {
  const { opinion, slidesCount } = useOpinionContext();
  const { triggerHapticFeedback } = useHapticFeedback();
  const {
    notificationStore: { setNotificationType, setNotificationMessage },
    pollsStore: { updateUniqueKeyToRefetchList },
    tournamentsStore: {
      updateUniqueKeyToRefetchList: updateUniqueKeyToRefetchListTournaments,
    },
  } = useStore();
  const swiper = useSwiper();
  const { t } = useTranslation();
  const { currentPage } = useNavigation();
  const { goBack } = useNavigation();

  const dislike = () => {
    triggerHapticFeedback('medium');
    OpinionsApi.dislikeOpinion({ id: opinion._id });
    setNotificationType(NOTIFICATION_TYPE.COMMON);
    setNotificationMessage(
      t('Got it! This opinion won’t appear in your feed anymore.'),
    );

    if (currentPage === PAGE.TOURNAMENT_ID_OPINION_ID) {
      updateUniqueKeyToRefetchListTournaments();
    } else updateUniqueKeyToRefetchList();

    if (swiper.activeIndex + 1 !== slidesCount) {
      swiper.slideNext();
    }
  };

  const close = () => {
    triggerHapticFeedback('medium');
    goBack();
  };

  return (
    <div
      className={styles.slide}
      style={{
        backgroundImage: item.banner ? `url(${item.banner})` : undefined,
      }}
    >
      <div className={styles.close} onClick={close}>
        <CloseIcon />
      </div>
      <div className={styles.dislike} onClick={dislike}>
        <DislikeIcon />
      </div>
      {!item.banner && <div className={styles.emoji}>{item.emoji}</div>}
      <div className={styles.overlay} />
      <div
        className={cn(
          styles.container,
          item._id === opinion._id && styles.active,
        )}
      >
        <OpinionSlideContent />
      </div>
    </div>
  );
};
